<div class="change-password">
  <form
    (ngSubmit)="change()"
    [formGroup]="form"
    class="change-password__form">
    <mat-form-field appearance="standard">
      <mat-label class="current-password__label">{{'Temporary password' | translate}}</mat-label>
      <input
        [placeholder]="'Temporary password' | translate"
        class="current-password__input"
        formControlName="currentPassword"
        matInput
        type="password">
      <mat-error *ngIf="form.get('currentPassword')?.hasError('required')">
        {{'Password required' | translate}}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label class="new-password__label">{{'New password' | translate}}</mat-label>
      <input
        [placeholder]="'New password' | translate"
        class="new-password__input"
        formControlName="newPassword"
        matInput
        type="password">
      <mat-error *ngIf="form.get('newPassword')?.hasError('required')">
        {{'Password required' | translate}}
      </mat-error>
      <mat-error *ngIf="form.get('newPassword')?.hasError('pattern')">
        {{'Password must contain at least one numeric character' | translate}}
      </mat-error>
      <mat-error
        *ngIf="form.get('newPassword')?.hasError('minlength') && !form.get('newPassword')?.hasError('pattern')">
        {{'Passwords must be at least 8 characters in length' | translate}}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label class="repeat-password__label">{{'Repeat password' | translate}}</mat-label>
      <input
        [errorStateMatcher]="errorStateMatcher"
        [placeholder]="'Repeat password' | translate"
        class="repeat-password__input"
        formControlName="repeatNewPassword"
        matInput
        type="password">
      <mat-error *ngIf="form.get('repeatNewPassword')?.hasError('required')">
        {{'Password required' | translate}}
      </mat-error>
      <mat-error *ngIf="form.get('repeatNewPassword')?.hasError('pattern')">
        {{'Password must contain at least one numeric character' | translate}}
      </mat-error>
      <mat-error
        *ngIf="form.get('repeatNewPassword')?.hasError('minlength') && !form.get('repeatNewPassword')?.hasError('pattern')">
        {{'Passwords must be at least 8 characters in length' | translate}}
      </mat-error>
      <mat-error
        *ngIf="form?.hasError('notSame') && !form.get('repeatNewPassword')?.hasError('required') && !form.get('repeatNewPassword')?.hasError('minlength') && !form.get('repeatNewPassword')?.hasError('pattern')">
        {{'Password doesn\'t match' | translate}}
      </mat-error>
    </mat-form-field>
    <button
      class="button button--rainbow change-password__submit-button"
      type="submit">{{'Change password' | translate}}</button>
  </form>
</div>
